import { Fragment, ReactNode } from "react";
import { BlockOutlined } from "@mui/icons-material";
import { alpha, Box, Typography, useTheme } from "@mui/material";
import {
  Check as CheckIcon,
  Close as CloseIcon,
  Remove as RemoveIcon,
  WarningAmber as WarningAmberIcon,
} from "@mui/icons-material";
import { getColor } from "~/lib/colors";
import { ScoreCard } from "./types";
import { SnoozeIcon } from "~/icons";
import { ExceptionTypeIcon } from "~/pages/findings/Exceptions/components/ExceptionTypeIcon";

type PolicyResultIconProps = {
  result: {
    result: keyof ScoreCard["scoreStats"] | "errorscan";
    value: number;
  };
};

type IconWrapperProps = {
  children: ReactNode;
};

export function PolicyResultDistribution({ result }: PolicyResultIconProps) {
  const theme = useTheme();
  const iconColor =
    result.value === 0
      ? theme.palette.text.disabled
      : getColor(theme, result.result);

  const IconWrapper = ({ children }: IconWrapperProps) => {
    return (
      <Box
        display="flex"
        justifyContent={"center"}
        alignItems={"center"}
        sx={(theme) => ({
          width: theme.spacing(3),
          height: theme.spacing(3),
          borderRadius: "50%",
          background: alpha(iconColor, 0.1),
        })}
      >
        {children}
      </Box>
    );
  };

  let icon = <div />;
  switch (result.result) {
    case "passed":
      icon = <CheckIcon sx={{ fontSize: "16px", color: iconColor }} />;
      break;

    case "failed":
      icon = <CloseIcon sx={{ fontSize: "16px", color: iconColor }} />;
      break;

    case "errorscan":
      icon = (
        <WarningAmberIcon
          sx={{
            fontSize: "14px",
            color: iconColor,
          }}
        />
      );
      break;

    // TODO: Remove Snoozed and disabled from use
    case "snoozed": //deprecated
      icon = <SnoozeIcon sx={{ fontSize: "16px", color: iconColor }} />;
      break;

    case "exceptions": //fallthrough
    case "disabled": //deprecated
      icon = <BlockOutlined sx={{ fontSize: "16px", color: iconColor }} />;
      break;

    case "skipped":
      icon = <RemoveIcon sx={{ fontSize: "16px", color: iconColor }} />;
      break;
  }

  return (
    <Fragment>
      <IconWrapper>{icon}</IconWrapper>
      <Typography sx={{ color: iconColor }}>{result.value}</Typography>
    </Fragment>
  );
}
